import { useStorage } from "@vueuse/core"
import type { ApiErrorResponse } from "~/types/api-error"

const uid = () => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`

export function useApiErrorNotifications() {
	const apiErrors = useStorage("omnect-apierrors", [] as ApiErrorResponse[])

	const addApiError = (error: ApiErrorResponse) => {
		error.id = uid()
		apiErrors.value = [...apiErrors.value, error]
	}

	const removeApiErrorWithTraceId = (traceId: string) => {
		apiErrors.value = apiErrors.value.filter((error) => error.traceId !== traceId)
	}

	function remove(id: string) {
		apiErrors.value = apiErrors.value.filter((n) => n.id !== id)
	}

	const clearApiErrors = () => {
		apiErrors.value = []
	}

	return { apiErrors, addApiError, clearApiErrors, removeApiErrorWithTraceId, remove }
}
